import axios from '@/utils/axiosHelper';

// 初始化数据(含授权)
export const onGetInitDataAPI = (params) => {
  return axios({ url: '/cherry/team/init', method: 'GET', params }, { interceptResultCode: false });
};

// 创立小队
export const onEstablishApi = (params) => {
  return axios({ url: '/cherry/team/join', method: 'POST', params }, { interceptResultCode: false });
};

// 助力初始化
export const onHelpGetInitDataAPI = (params) => {
  return axios({ url: '/cherry/team/help', method: 'GET', params }, { interceptResultCode: false });
};

// 加入队伍
export const onHelpJoinTeamAPI = (params) => {
  return axios({ url: '/cherry/team/entry', method: 'POST', params }, { interceptResultCode: false });
};

// 账号注销切换
export const onLogoutApi = (params) => {
  return axios({ url: '/cherry/team/logout', method: 'POST', params }, { interceptResultCode: false });
};

// 绑定角色并领取奖励
export const onTeamBindApi = (params) => {
  return axios({ url: '/cherry/team/bind', method: 'POST', params }, { interceptResultCode: false });
};


// WEBPACK FOOTER //
// ./src/pages/sakura/lottery/api.js